import { ConfirmResponse } from "../api/ConfirmResponse";

export class ConfirmResult {
	requiresPayment: boolean;
	bookingReference: string;
	redirectUrl: string;

	constructor(resp: ConfirmResponse) {
		this.requiresPayment = resp.requiresPayment;
		this.bookingReference = resp.id;
		this.redirectUrl = resp.redirectUrl;
	}
}